import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import ImageAiProcessing from '~/core/components/FullscreenImageEditor/ImageAiProcessing.vue';
import EditorTemplate from './EditorTemplate.vue';
import ImageDrawer from './ImageDrawer.vue';
import ImageCropper from './ImageCropper.vue';
import ActionBtn from './ActionBtn.vue';
export default defineComponent({
  name: 'FullscreenImageEditor',
  components: {
    ImageAiProcessing: ImageAiProcessing,
    EditorTemplate: EditorTemplate,
    ActionBtn: ActionBtn,
    ImageCropper: ImageCropper,
    ImageDrawer: ImageDrawer
  },
  props: {
    mode: {
      type: String,
      default: 'full'
    }
  },
  emits: ['save', 'close'],
  setup: function setup(props, _ref) {
    var emit = _ref.emit,
      expose = _ref.expose;
    var isActive = ref(false);
    var url = ref(null);
    var originalFile = ref(null);
    var editedFile = ref(null);
    var currentAction = ref('preview');
    onBeforeUnmount(function () {
      revokeObjectURL();
    });
    function revokeObjectURL() {
      if (url.value) {
        URL.revokeObjectURL(url.value);
      }
    }
    function handleImageEdited(image) {
      URL.revokeObjectURL(url.value);
      editedFile.value = image;
      if (props.mode === 'only_crop') {
        handleSaveImage();
        return;
      }
      url.value = URL.createObjectURL(image);
      currentAction.value = 'preview';
    }
    function handleImageAiProcessed(image) {
      if (url.value) {
        URL.revokeObjectURL(url.value);
      }
      editedFile.value = image;
      url.value = URL.createObjectURL(image);
      currentAction.value = 'crop';
    }
    var show = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(src) {
        var _ref3,
          isWithOptimization,
          loadedSrc,
          response,
          blob,
          _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _ref3 = _args.length > 1 && _args[1] !== undefined ? _args[1] : {}, isWithOptimization = _ref3.isWithOptimization;
              if (isWithOptimization) {
                currentAction.value = 'ai-processing';
              } else {
                currentAction.value = props.mode === 'only_crop' ? 'crop' : 'preview';
              }
              editedFile.value = null;
              isActive.value = true;
              if (!(src instanceof File || typeof src === 'string')) {
                _context.next = 8;
                break;
              }
              _context.t0 = src;
              _context.next = 11;
              break;
            case 8:
              _context.next = 10;
              return src();
            case 10:
              _context.t0 = _context.sent;
            case 11:
              loadedSrc = _context.t0;
              if (!(typeof loadedSrc === 'string')) {
                _context.next = 22;
                break;
              }
              _context.next = 15;
              return fetch(loadedSrc);
            case 15:
              response = _context.sent;
              _context.next = 18;
              return response.blob();
            case 18:
              blob = _context.sent;
              url.value = URL.createObjectURL(blob);
              originalFile.value = new File([blob], 'Изображение', {
                type: blob.type
              });
              return _context.abrupt("return");
            case 22:
              url.value = URL.createObjectURL(loadedSrc);
              originalFile.value = loadedSrc;
            case 24:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function show(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    function hide() {
      isActive.value = false;
      revokeObjectURL();
      url.value = null;
      originalFile.value = null;
    }
    function handleClose() {
      emit('close', originalFile.value);
      hide();
    }
    function handleSaveImage() {
      var _editedFile$value;
      emit('save', (_editedFile$value = editedFile.value) !== null && _editedFile$value !== void 0 ? _editedFile$value : originalFile.value);
      hide();
    }
    expose({
      show: show,
      hide: hide
    });
    return {
      isActive: isActive,
      url: url,
      currentAction: currentAction,
      originalFile: originalFile,
      handleImageEdited: handleImageEdited,
      handleImageAiProcessed: handleImageAiProcessed,
      handleClose: handleClose,
      handleSaveImage: handleSaveImage
    };
  }
});